import type { ClientToServerEvents, ServerToClientEvents } from '@pixelworld/shared';
import { io, type Socket } from 'socket.io-client';

export type GameSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/**
 * Connects to the game server on the same origin as the page. The session
 * cookie logs the player in. After a dropped connection Socket.IO keeps trying
 * for about a minute, which matches how long the server keeps the player's place.
 */
export function createGameSocket(): GameSocket {
  return io({
    autoConnect: false,
    reconnectionAttempts: 15,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });
}
